import EmptyView1 from '../../layouts/EmptyView1'
import ErrorPage from './ErrorPage'

export default EmptyView1(ErrorPage)



// WEBPACK FOOTER //
// ./src/pages/error-page/index.js